/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import { initReactI18next } from "react-i18next";
import i18next from 'i18next';
import availableLanguages from "../Languages/availableLanguages";

const el = require('../Languages/el.json');
const en = require('../Languages/en.json');
const de = require('../Languages/de.json');

let DOMAIN = 'at';
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // Development code build
    //console.log('Development code build');
    DOMAIN = 'at';
} else {
    // production code build
    //console.log('Production code build');
    let _extension = window.location.origin.split('.').at(-1);
    if( _extension == 'dev' ){
        _extension = 'at';
    }
    DOMAIN = _extension;
}

i18next
    .use(initReactI18next)
    .init({
        debug: false,
        fallbackLng: `${availableLanguages[DOMAIN].default}`,
        lng: localStorage.getItem('autoRecLang') ? JSON.parse(localStorage.getItem('autoRecLang')) : availableLanguages[DOMAIN].default,           //Το χρησιμοποιώ στο app.js για το fallback της γλωσσας
        extension: DOMAIN,                                      //Δικο μου property για να αποθηκευσω το DOMAIN. Το χρησιμοποιώ στο useLang
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        // language resources
        resources: {
            en: {
                translation: en
            },
            el: {
                translation: el
            },
            de: {
                translation: de
            },
        }
    });

export default i18next;